interface IItemListEntry {
  name: string;
  url: string;
}

const itemListMarkupSchema = (items: IItemListEntry[]) => {
  return {
    '@type': 'ItemList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      url: item.url,
    })),
  };
};

export default itemListMarkupSchema;
